import { COLORS } from '@/Colors';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import React, { FC, useState } from 'react';

interface ConfirmButtonProps extends ButtonProps {
  confirmMessage?: string;
}
const ConfirmButton: FC<React.PropsWithChildren<ConfirmButtonProps>> = ({
  confirmMessage = 'Confermi?',
  ...props
}) => {
  const [firstClick, setFirstClick] = useState(false);

  const finalClick = (e: any) => {
    props.onClick && props.onClick(e);
    setFirstClick(false);
  };

  return (
    <div>
      {firstClick ? (
        <div>
          <Space align="center">
            <div>{confirmMessage}</div>
            <Button
              icon={<CheckCircleOutlined style={{ color: COLORS.success }} />}
              onClick={finalClick}
            />
            <Button
              icon={<CloseCircleOutlined style={{ color: COLORS.error }} />}
              onClick={() => setFirstClick(false)}
            />
          </Space>
        </div>
      ) : (
        <Button {...props} onClick={() => setFirstClick(true)} />
      )}
    </div>
  );
};

export default ConfirmButton;
